import { combineReducers } from 'redux';
import appReducer, { AppReducerState } from './appReducer';
import profileReducer, { ProfileReducerState } from './profileReducer';
import navReducer, { NavReducerState } from './navReducer';
import generalReducer, { GeneralReducerState } from './generalReducer';
import deltaReducer, { DeltaReducerState } from './deltaReducer';
import resultsReducer, { ResultsReducerState } from './resultsReducer';

export interface RootState {
    appReducer: AppReducerState;
    profileReducer: ProfileReducerState;
    generalReducer: GeneralReducerState;
    navReducer: NavReducerState;
    deltaReducer: DeltaReducerState;
    resultsReducer: ResultsReducerState;
}

const reducers = combineReducers<RootState>({
    appReducer,
    navReducer,
    generalReducer,
    profileReducer,
    deltaReducer,
    resultsReducer
});

export default reducers;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/index.ts